import { Translation } from "@/data/lang";

import { ButtonGroupProps } from "ui/core/button-group";

export type WhaleInterestFactorKey = "instOwnshp" | "instCount";

export const getWhaleInterestFactors = ({
  t,
  symbol,
}: {
  t: Translation;
  symbol: string;
}): ButtonGroupProps["options"] => [
  {
    label: t.analysis.chip.factor.holdingRate,
    value: "instOwnshp",
    tooltip: t.analysis.chip.factor.whaleInterestRateDialog,
  },
  {
    label: t.analysis.chip.factor.symbolInstitutionNumber({ symbol }),
    value: "instCount",
  },
];
